// LICENSE : MIT
"use strict";
const MapLike = require("map-like");
export default class MemoryDB extends MapLike {

}



// WEBPACK FOOTER //
// ./src/js/infra/adpter/MemoryDB.js